import axios from 'axios';
import { LOCAL_STORE_APIKEY } from '../../Share/constants';
import { errorInterceptor, responseInterceptor } from './apiInterceptor';

const apiVersion = process.env.REACT_APP_REPORT_API_VERSION;
const apiKey = process.env.REACT_APP_REPORT_API_KEY;
const reportAxios = axios.create({
  baseURL: process.env.REACT_APP_REPORT_API,

});
// api interceptors
reportAxios.interceptors.response.use(responseInterceptor, errorInterceptor);

export function GetDataFromScource(urlPart, from, to, agreements, customerNumber, groupColumns = '') {
  return reportAxios.get(`/api/${apiVersion}/reportData/${urlPart}?from=${from}&to=${to}&agreements=${agreements}&groupColumns=${groupColumns || ''}`, {
    headers: {
      customerNumber: localStorage.getItem('SELECTER_CUSTOMER_NUMBER') || customerNumber,
      apiKey,
    },
  });
}
